import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { LogOut, LayoutDashboard, Building2, Mail, BarChart3, FileText, Menu, X, Map, Utensils, Flag, Users } from 'lucide-react';
import { useState } from 'react';
import { logout, getAdminEmail } from '../../utils/auth';
import './AdminLayout.scss';

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const menuItems = [
        { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
        { path: '/mosques', icon: Building2, label: 'Mosques' },
        { path: '/mosques/map', icon: Map, label: 'Map View' },
        { path: '/restaurants', icon: Utensils, label: 'Restaurants' },
        { path: '/contributors', icon: Users, label: 'Contributors' },
        { path: '/campaigns', icon: Mail, label: 'Campaigns' },
        { path: '/analytics', icon: BarChart3, label: 'Analytics' },
        { path: '/reports', icon: Flag, label: 'Reports' },
        { path: '/logs', icon: FileText, label: 'Logs' }
    ];

    const isActive = (path) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };

    return (
        <div className="admin-layout">
            <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
                <div className="sidebar-header">
                    <h2>Chorulla Palli</h2>
                    <button
                        className="sidebar-toggle"
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                    >
                        {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
                    </button>
                </div>

                <nav className="sidebar-nav">
                    {menuItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <button
                                key={item.path}
                                className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
                                onClick={() => navigate(item.path)}
                            >
                                <Icon size={20} />
                                {sidebarOpen && <span>{item.label}</span>}
                            </button>
                        );
                    })}
                </nav>
            </aside>

            <div className="main-content">
                <header className="admin-header">
                    <div className="header-content">
                        <h1>Admin Dashboard</h1>
                        <div className="header-actions">
                            <span className="admin-email">{getAdminEmail()}</span>
                            <button className="logout-button" onClick={handleLogout}>
                                <LogOut size={18} />
                                Logout
                            </button>
                        </div>
                    </div>
                </header>

                <main className="content-area">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
